import React, { useState, useMemo } from 'react'
import qs from 'qs'
import classNames from 'classnames'
import { BatchItem } from 'component'
import Tooltip from 'meinian-package/src/baseComponent/tooltip'
import { ossImg } from 'meinian-package/src/utils/image'
import moment from 'moment'
import Icon from 'meinian-package/src/component/icon'
import util from 'meinian-package/src//utils/util'
import ImageDetail from 'view/detail/imageDetail'
import { getPlatformConfig, CONFIG_KEY } from 'view/detail/imageDetail/infoView/info/originalText/config'
import { hasFromData } from 'view/detail/imageDetail/infoView/info/originalText'
import { MARK_STATUS } from 'meinian-package/src/component/enum'
import { Layer } from '../image.base'
import OriginLink from '../../originLink'
import { StyleStateLabel } from '../styleInfo'
import styles from './index.module.less'

export default (props) => {
  const {
    minWidth,
    isBatch,
    columnWidth,
    onClickCard,
    total,
    maxHeight = 500,
    data = [],
    shareUrl,
    // trackSourceType, // 埋点来源类型
    itemData,
    action,
    viewConfig = {}, // 视图设置
  } = props
  const [lastRouter] = useState(location.pathname + location.search)
  const [visible, setVisible] = useState()

  const {
    isFromZkPlatform,
    collectId,
    platformId,
    imageEntityExtend,
    mainUrl,
    imageGroupEntityId,
    inspirationId,
    loginUserInfo,
    height,
    width,
  } = itemData || {}

  const _onChange = (success, newItemData) => {
    if (success) {
      action.onUpdate(newItemData)
      props.onResize?.()
      props.onRefresh?.(newItemData)
    }
  }
  const { config } = getPlatformConfig(platformId, isFromZkPlatform)
  if (!config) {
    return
  }
  const infoBlock = config[CONFIG_KEY.CARD_INFO_BLOCK] ? config[CONFIG_KEY.CARD_INFO_BLOCK] : config[CONFIG_KEY.INFO_BLOCK] || []

  const infoHeight = useMemo(() => {
    let _height = 126
    if (!infoBlock.length || !viewConfig.originalInfo) {
      _height -= 30
    }
    if (!imageEntityExtend?.styleTitle) {
      _height -= 24
    }
    return _height
  }, [itemData])

  const auth = loginUserInfo?.inspirationPermissions || []
  const cardHeight = viewConfig.imageTextType === 'proportionally'
    ? columnWidth + infoHeight
    : Math.round((columnWidth * height) / width) + infoHeight

  return (
    <div
      style={{
        background: '#fff',
        borderRadius: '9px',
        overflow: 'hidden',
        minWidth,
        width: columnWidth,
        height: cardHeight,
        maxHeight,
      }}
    >
      {isBatch ? (
        <div className={classNames('meinian-waterfall-card-image')} style={{ height: `calc(100% - ${infoHeight}px)` }}>
          <div className="batch-mask">
            <BatchItem keyValue={`${imageGroupEntityId},${inspirationId}`} className="batch-check" info={itemData} />
          </div>
          <img
            referrerPolicy="no-referrer"
            loading="lazy"
            src={ossImg(mainUrl, 400)}
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </div>
      ) : (
        <div
          className={classNames('meinian-waterfall-card-image')}
          style={{ height: `calc(100% - ${infoHeight}px)` }}
          onClick={(e) => {
            if (window.location.pathname.startsWith('/meinian/home/workbench')) {
              util.track('mn-workbench-click', {
                module1: '款式查看',
                module2: props.trackModule2,
                module3: '款式详情',
              })
            }
            history.replaceState(
              {},
              '',
              `/meinian/detail/image?${qs.stringify({
                imageGroupEntityId,
                inspirationId,
                collectId,
                shareUrl,
                fromPage: location.pathname + location.search
              })}`
            )
            onClickCard ? onClickCard(itemData, e) : setVisible(true)
          }}
        >
          {columnWidth >= 180 && (
            <Layer
              showMoveImage={props.showMoveImage}
              childrenFlag={props.childrenFlag}
              allStyleFlag={props.allStyleFlag}
              onDeleteItem={() => {
                action.onDelete([itemData.imageGroupEntityId, itemData.inspirationId])
                props.onResize()
              }}
              hiddenMark={viewConfig.markInfo}
              onChange={_onChange}
              itemData={itemData}
            />
          )}
          <img
            referrerPolicy="no-referrer"
            loading="lazy"
            src={ossImg(itemData.mainUrl, 400)}
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
          <StyleStateLabel auth={auth} itemData={itemData} viewConfig={viewConfig} />
        </div>
      )}
      <Info item={itemData} infoHeight={infoHeight} viewConfig={viewConfig} />
      {visible ? (
        <ImageDetail
          list={data}
          maxListLength={total || data.length}
          onChangeIndex={props.onChangeIndex}
          visible={visible}
          onChange={_onChange}
          onVisibleChange={(_visible) => {
            history.replaceState({}, '', lastRouter)
            setVisible(_visible)
          }}
          onDeleteItem={(record) => {
            action.onDelete([record.imageGroupEntityId, record.inspirationId])
            props.onResize()
          }}
          initWaterfall={props.initWaterfall}
          initSubColls={props.initSubColls}
        />
      ) : null}
    </div>
  )
}

const Info = (props) => {
  const { infoHeight, viewConfig, item } = props
  const { config, dtoConfig } = getPlatformConfig(item.platformId, item.isFromZkPlatform)
  const dto = item?.[dtoConfig?.dto]
  const sourTime = config?.[CONFIG_KEY.OPTION_ITEM]?.find((i) => i.valueKey === 'sourceTime')
  const infoBlock = config[CONFIG_KEY.CARD_INFO_BLOCK] ? config[CONFIG_KEY.CARD_INFO_BLOCK] : config[CONFIG_KEY.INFO_BLOCK] || []
  const getLinkText = () => {
    const platform = dtoConfig?.label || item[dtoConfig?.labelKey] || hasFromData(dtoConfig, item, dto)
    let collectFrom = ''

    if (dtoConfig?.collectFrom) {
      if (dtoConfig.collectFrom.includes('.')) {
        // 处理 'xxx.yyy' 格式
        const keys = dtoConfig.collectFrom.split('.')
        collectFrom = keys.reduce((obj, key) => obj?.[key], dto) || ''
      } else {
        // 处理普通格式
        collectFrom = dto?.[dtoConfig.collectFrom] || ''
      }
    }

    return [platform, collectFrom].filter(Boolean).join('-')
  }

  const getVerifyText = (markTimes, markStatus) => {
    const passText = ['待审核', '一审通过', '二审通过', '三审通过', '四审通过', '五审通过', '六审通过', '七审通过', '八审通过']
    const rejectText = ['待审核', '一审驳回', '二审驳回', '三审驳回', '四审驳回', '五审驳回', '六审驳回', '七审驳回', '八审驳回']
    return markStatus === MARK_STATUS.NOT_PASS ? rejectText[markTimes] : passText[markTimes]
  }

  const getStatusText = () => {
    // 卡片显示当前状态
    if (item.markTimes === item.needMarkTimes) return null
    if (!item.materialFlag && item.hasMarkPermissions) return getVerifyText(item.markTimes, item.markStatus)
    if (item.markStatus === MARK_STATUS.UNSET) return '待提审'
    return getVerifyText(item.markTimes, item.markStatus)
  }
  return (
    <div className={styles['mn-waterfall-image-detail-info']} style={{ height: infoHeight }}>
      {item?.imageEntityExtend?.styleTitle ? <div className="style-title">{item?.imageEntityExtend?.styleTitle}</div> : null}
      <div className="mn-waterfall-image-detail-info-1">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span className="user-name">{item.userName}</span>
          <span style={{ color: 'var(--m-text-3)', margin: '0 4px' }}>采自</span>
          {dtoConfig && (
            <OriginLink style={{ color: '#0065D9', maxWidth: '110px' }} item={item} className="platformOriginLink" platformId={item.platformId}>
              {getLinkText()}
            </OriginLink>
          )}
        </div>
        {getStatusText()}
      </div>
      <div className="mn-waterfall-image-detail-info-2">
        <div className="mn-waterfall-image-detail-info-2-left">
          <Icon type="m-wenjianjia" className="info-inspiration-path-wrap-icon" />
          <Tooltip title={item.inspirationNamePath}>
            <div className="info-inspiration-path text-overflow">{item.inspirationNamePath}</div>
          </Tooltip>
        </div>
        <div style={{ color: 'var(--m-text-1)' }}>
          {moment(item.sourceTime).format('YYYY/MM/DD')}
          {sourTime?.label.slice(0, 2)}
        </div>
      </div>
      {viewConfig.originalInfo && dto && !!infoBlock.length && (
        <div className="mn-waterfall-image-detail-info-3">
          <div className="datum">
            {infoBlock.map((blockInfo) => (
              <span className="data-item">
                <Tooltip placement="bottom" title={blockInfo.label}>
                  <Icon type={blockInfo.icon} />
                </Tooltip>
                <span className="data-item-num">
                  {
                    // eslint-disable-next-line react/jsx-no-useless-fragment
                    Array.isArray(blockInfo.valueKey) ? (
                      <>
                        {`${hasFromData(blockInfo, dto[blockInfo.valueKey[0]])}/${hasFromData(
                          blockInfo,
                          dto[blockInfo.valueKey[1]]
                        )}`}
                      </>
                    ) : (
                      <>{hasFromData(blockInfo, dto[blockInfo.valueKey])}</>
                    )
                  }
                </span>
              </span>
            ))}
          </div>{' '}
        </div>
      )}
    </div>
  )
}
